import React from "react";

/**
 * Lightweight modal — used by admin pages. No external deps.
 */
export function Modal({ open, onClose, title, subtitle, children, size = "md", testId }) {
  if (!open) return null;
  const sizes = {
    sm: "max-w-md",
    md: "max-w-xl",
    lg: "max-w-3xl",
    xl: "max-w-5xl",
  };
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center px-4 py-8"
      data-testid={testId}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div className="absolute inset-0 bg-navy/50 backdrop-blur-sm" aria-hidden />
      <div className={`relative w-full ${sizes[size] || sizes.md} bg-white border border-white/20 shadow-2xl rounded-lg max-h-[90vh] overflow-hidden flex flex-col`}>
        <div className="px-6 py-4 border-b border-navy/10 flex items-start justify-between">
          <div>
            {title ? <div className="font-heading text-ink text-lg">{title}</div> : null}
            {subtitle ? <div className="text-ink-muted text-xs mt-1">{subtitle}</div> : null}
          </div>
          <button
            onClick={onClose}
            className="text-ink-muted hover:text-ink text-2xl leading-none px-2"
            aria-label="Close"
            data-testid="modal-close-btn"
          >×</button>
        </div>
        <div className="px-6 py-5 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}

export function ModalFooter({ children }) {
  return (
    <div className="mt-6 pt-4 border-t border-navy/10 flex items-center justify-end gap-2">
      {children}
    </div>
  );
}
